<form
  [formGroup]="formData"
  novalidate
  (ngSubmit)="save()"
  [ngClass]="{ submitted: submitted }"
>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body factory_admin">
    <div class="row">
      <div class="col-md-12">
        <table class="table table-stripe">
          <thead>
            <tr>
              <th>Label</th>
              <th>Min</th>
              <th>Max</th>
              <th>Discount(%)</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody formArrayName="discount_structure">
            <tr
              *ngFor="
                let item of formData['controls'].discount_structure['controls'];
                let idx = index
              "
              [formGroupName]="idx"
            >
              <td class="text-right">
                <input type="text" formControlName="label" class="form-control" />
              </td>
              <td class="text-right">
                <input type="number" formControlName="min" class="form-control" />
              </td>
              <td class="text-right">
                <input type="number" formControlName="max" class="form-control" />
              </td>
              <td class="text-right">
                <input
                  type="number"
                  formControlName="discount"
                  class="form-control"
                />
              </td>
              <td>
                <a
                  class="row-action-del"
                  href="javascript:;"
                  (click)="removeRow(idx)"
                >
                  <i class="fas fa-times text-danger"></i>
                </a>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="5" class="text-center">
                <button
                  class="btn btn-sm btn-info"
                  type="button"
                  (click)="addRow()"
                >
                  <i class="fas fa-plus"></i> Add Row
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-default mr-1"
      type="button"
      (click)="activeModal.dismiss('')"
    >
      Cancel
    </button>
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="loading"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
    >
      Submit
    </button>
  </div>
</form>
